import { render, staticRenderFns } from "./ContactCustomerServicePreview.vue?vue&type=template&id=2e70f16c&scoped=true"
import script from "./ContactCustomerServicePreview.vue?vue&type=script&lang=js"
export * from "./ContactCustomerServicePreview.vue?vue&type=script&lang=js"
import style0 from "./ContactCustomerServicePreview.vue?vue&type=style&index=0&id=2e70f16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70f16c",
  null
  
)

export default component.exports